// extracted by mini-css-extract-plugin
export default {"PostJob":"PostJob_PostJob__XzXD7","PostNav":"PostJob_PostNav__qf9O4","help":"PostJob_help__cUFLE","PostBody":"PostJob_PostBody__EQss7","button":"PostJob_button__kcQdf"};